import React, { useEffect, useState } from "react";

/** Click-to-edit cell that commits on blur or Enter and reverts on Escape. */
export const EditCell = ({ value, onCommit, type = "text", options, testId, align = "left", placeholder = "—", className = "", suffix = "", prefix = "" }) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value ?? "");

  useEffect(() => { setDraft(value ?? ""); }, [value]);

  const commit = () => {
    setEditing(false);
    const next = type === "number" ? Number(draft) : draft;
    if (String(next ?? "") !== String(value ?? "")) onCommit(next === "" ? null : next);
  };

  if (!editing) {
    const shown = value != null && value !== "" ? `${prefix}${value}${suffix}` : "";
    return (
      <button
        data-testid={testId}
        onClick={() => setEditing(true)}
        title="Click to edit"
        className={`-mx-1 w-full rounded px-1 py-0.5 text-${align} transition-colors hover:bg-amber-50 ${shown ? "text-slate-700" : "text-slate-300"} ${className}`}
      >
        {shown || placeholder}
      </button>
    );
  }

  if (options) {
    return (
      <select
        data-testid={`${testId}-select`}
        autoFocus
        value={draft || ""}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commit}
        className="w-full rounded border border-slate-300 bg-white px-1 py-0.5 text-sm outline-none focus:border-[color:var(--brand-primary)]"
      >
        <option value="">—</option>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    );
  }

  return (
    <input
      data-testid={`${testId}-input`}
      autoFocus
      type={type}
      min={type === "number" ? 0 : undefined}
      value={draft ?? ""}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === "Enter") commit();
        if (e.key === "Escape") { setDraft(value ?? ""); setEditing(false); }
      }}
      className="w-full rounded border border-slate-300 px-1 py-0.5 text-sm outline-none focus:border-[color:var(--brand-primary)]"
    />
  );
};
